<template>
    <transition>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0">
                                <li class="breadcrumb-item active">Settings </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);"> Discount Setup</a></li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body" v-if="!loading">
                            <div class="wpr_table">
                                <div class="general_wrapper">
                                    <div class="general_row_wrap">
                                        <div class="wpr_general_sign_title">
                                            Afflicable Discount Setup For Diagnosis Test </div>
                                        <div class="wpr_general_row">
                                            <div class="wpr_general_content">                                                    
                                                <table class="form-table wp-list-table widefat fixed striped">
                                                    <tbody class="wpr_thankyouorder_tbody">
                                                        <tr valign="top" style="border-bottom: 2px solid #ddd; padding-bottom: 10px;">
                                                            <th style="width: 20%;">Name</th>
                                                            <th style="width: 10%;">Discount (%)</th>
                                                            <th style="width: 10%;">Flat Discount</th>
                                                            <th style="width: 10%;">Use Daterange</th>
                                                            <th style="width: 10%;">Start Date</th>
                                                            <th style="width: 10%;">End Date</th>
                                                            <th style="width: 10%; text-align: center;">Status</th>
                                                            <th style="width: 10%; text-align: center;">Action</th>
                                                        </tr> 
                                                        <tr valign="top" v-for="(item, i) in form.discount_items" :key="item.id">
                                                            <td >
                                                                <label for="discount_title_{{ i }}">
                                                                    <input type="text" id="discount_title_{{ i }}" class="form-control" placeholder="Discount Title"  
                                                                    v-model="item.name">
                                                                </label>
                                                            </td>
                                                            <td >
                                                                <label for="discount_percent_{{ i }}">
                                                                    <input type="text" id="discount_percent_{{ i }}" class="form-control" placeholder="Discount Percent"  
                                                                    v-model="item.discount_percent" @input="checkPercentFlat(item, i, 'percent')">
                                                                </label>
                                                            </td>
                                                            <td >
                                                                <label for="flat_discount_{{ i }}">
                                                                    <input type="text" id="flat_discount_{{ i }}" class="form-control" placeholder="Flat Discount"  
                                                                    v-model="item.discount_flat_val" @input="checkPercentFlat(item, i, 'flat')">
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <label class="custom-checkbox">
                                                                    <input type="checkbox" v-model="item.is_daterange">
                                                                    <span class="checkmark">{{ item.is_daterange ? 'Yes' : 'No' }}</span> <!-- Optional text inside the checkbox -->
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <label for="start_date_{{ i }}">
                                                                    <input v-if="item.is_daterange" type="date" id="start_date_{{ i }}" class="form-control" v-model="item.start_date">
                                                                    <input v-else type="date" id="start_date_{{ i }}" class="form-control" v-model="item.start_date" disabled>
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <label for="end_date_{{ i }}">
                                                                    <input v-if="item.is_daterange" type="date" id="end_date_{{ i }}" class="form-control" v-model="item.end_date">
                                                                    <input v-else type="date" id="end_date_{{ i }}" class="form-control" v-model="item.end_date" disabled>
                                                                </label>
                                                            </td>
                                                            <td>
                                                                <label class="switch">
                                                                    <input type="checkbox" v-model="item.status">
                                                                    <span class="switch_label"></span>
                                                                </label>
                                                            </td> 
                                                            <td style="text-align: center;"> 
                                                                <a href="javascript:void(0);" class="btn btn-sm btn-warning" @click="updateItem(item)" v-if="item.id != ''" title="Click to Update" style="margin-right: 2px;"> <i class="fas fa-edit"></i></a>
                                                                <a href="javascript:void(0);" class="btn btn-sm btn-danger" @click="removeItem(i, item.id)" title="Click to Delete"><i class="fas fa-trash"></i></a>
                                                            </td>  
                                                        </tr>

                                                    </tbody>
                                                </table> 
                                                <div class="row pt-2">
                                                    <div class="d-grid">
                                                        <button type="button" class="btn btn-primary" @click="addDiscountItem()"> <i class="fa fa-plus"></i> Add More</button> 
                                                    </div> 
                                                    </div> 
                                            </div>
                                        </div>
                                        
                                    </div>

                                </div>
                            </div>
                            <div class="clear"></div>
                            <p class="submit">
                                <button type="button" class="btn btn-sm btn-success" @click="submitDiscountItem()" :disabled="disabled">Submit</button> 
                            </p>
                        </div>
                        
                        <div class="tab-pane show active" v-if="loading">
                            <div class="row"> 
                                <div class="col-md-5">  
                                </div>
                                <div class=" col-md-2"> 
                                    <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                </div>
                                <div class="col-md-5">  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </transition>
</template>
<script>
import Modal from "./../../helper/Modal";
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Company',
    components: {},
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode: false,
            disabled: false,
            modalActive: false,
            errors: {},
            logoPreview: '',
            btn: 'Create',
            loading: true,
            isCheckedDaterange: false,
            isCheckedStatus: false,
            items: [],
            more_order_points:[], 
            form: new Form({
                discount_items: [
                    {id:'', name:'', discount_percent:'', discount_flat_val:'', is_daterange:false, start_date:'', end_date:'', status:false}
                ], 
            }),
        };
    },
    components: {
        Modal,
    },
    created() {
        this.fetchIndexData();
    },
    methods: {
        toggleUseDaterange: function(event) {
            this.isCheckedDaterange = event.target.checked;
        },

        toggleStatus: function(event) {
            this.isCheckedStatus = event.target.checked;
        },

        toggleModal: function() {
            this.modalActive = !this.modalActive;
            if (!this.modalActive) {
                this.editMode = false;
                this.btn = 'Create';
            }
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();
        },

        checkPercentFlat: function(item, index, type) { 
            if(type == 'percent'){
                if(item.discount_percent < 0){
                    item.discount_percent = 0;
                }else if(item.discount_percent > 100){
                    item.discount_percent = 100;
                }
                item.discount_flat_val = 0;
            }else if(type == 'flat'){
                if(item.discount_flat_val < 0){
                    item.discount_flat_val = 0;
                }
                item.discount_percent = 0;
            } 
            // direct assignment works in Vue 3
            this.form.discount_items[index] = { ...item };
        },

        addDiscountItem : function(){ 
          let r = (Math.random() + 1).toString(36).substring(7);
          
          const newObj = {id:'',name:'', discount_percent:'', discount_flat_val:'', is_daterange:false, start_date:'', end_date:'', status:false}
          this.form.discount_items.push(newObj);
        },

        removeItem : function(index, item_id){ 
          if(item_id != ""){
              this.deleteItem(item_id);
          }else{
              this.form.discount_items.splice((index), 1);
          }
          //this.more_order_points.splice(index, 1);
        },

        fetchIndexData() { 
            this.loading = true;
            axios.get(this.apiUrl + '/hm/diagnosis_discounts', this.headerjson)
                .then((res) => {
                    var response_discount_items = res.data.data.map(item => {
                        // Modify the properties as needed
                        item.is_daterange = item.is_daterange === 1;
                        item.status = item.status === 1;

                        // Return the modified item
                        return item;
                    });
                    console.log("sjbfjs=== ", response_discount_items);
                    this.form.discount_items = response_discount_items;    
                })
                .catch((err) => { 
                    this.$toast.error(err.response.data.message);
                }).finally((ress) => {
                    this.loading = false;
                });
        },

        edit: function(item) {
            this.btn = 'Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item);
            this.logoPreview = '';
        }, 

        submitDiscountItem: function(e) {
            this.isSubmit = true;
            this.disabled = true;
            if (this.items.length > 0) { 
                var postEvent = axios.put(this.apiUrl + '/hm/diagnosis_discounts' + this.form.id, this.form, this.headerjson);
            } else { 
                var postEvent = axios.post(this.apiUrl + '/hm/diagnosis_discounts', this.form, this.headerjson);
            }
            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if (res.status == 200) {
                    this.toggleModal();
                    this.fetchIndexData();
                    this.$toast.success(res.data.message);
                } else {
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {
                this.isSubmit = false;
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if (err.response.status == 422) {
                    this.errors = err.response.data.errors
                }
            });
        },
        
        updateItem: function(item) {  
            this.$swal({
                title: 'Are you sure?',
                text: "You want update this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, Update it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.put(this.apiUrl+'/hm/diagnosis_discounts/'+item.id, item,  this.headerjson)
                    .then(res => {
                        console.log(res);
                        if(res.status == 200){ 
                          this.fetchIndexData();
                          this.$toast.success(res.data.message); 
                        }else{
                          this.$toast.error(res.data.message);
                        } 
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message);
                        if(err.response.status == 422){
                            this.errors = err.response.data.errors 
                        }
                    }); 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        deleteItem: function(id) {  
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/diagnosis_discounts/'+id, this.headers)
                    .then(res => {
                        if(res.status == 200){ 
                          this.fetchIndexData();
                          this.$toast.success(res.data.message); 
                        }else{
                          this.$toast.error(res.data.message);
                        } 
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message);
                        if(err.response.status == 422){
                            this.errors = err.response.data.errors 
                        }
                    }); 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },
         
        validation: function(...fiels) {
            var obj = new Object();
            var validate = false;
            for (var k in fiels) { // Loop through the object  
                for (var j in this.form) {
                    if ((j == fiels[k]) && (!this.form[j])) {
                        obj[fiels[k]] = fiels[k].replace("_", " ") + ' field is required'; // Delete obj[key]; 
                        this.errors = { ...this.errors, ...obj };
                    } else {
                        validate = false;
                    }
                }
            }
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },

        onkeyPress: function(field) {
            for (var k in this.errors) { // Loop through the object
                if (k == field) { // If the current key contains the string we're looking for 
                    delete this.errors[k]; // Delete obj[key];
                }
            }
        }, 
    },
    destroyed() {

    },
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {  
        daterangeCheckboxValue() {
            return this.isCheckedDaterange ? 1 : 0;
        },
        statusCheckboxValue() {
            return this.isCheckedStatus ? 1 : 0;
        },
    }

}
</script>
<style scoped>
#mwb_rwpr_setting_wrapper * {
    box-sizing: border-box;
}

.mwb_rwpr_content_template {
    box-shadow: -2px 0 5px -1px rgba(0, 0, 0, .05);
    color: #555d66;
    font-size: 16px;
    flex: 0 0 80%;
    padding: 10px 30px 10px 40px;
    position: relative;
    line-height: 28px;
}

#mwb_rwpr_setting_wrapper * {
    box-sizing: border-box;
}

#mwb_rwpr_setting_wrapper * {
    box-sizing: border-box;
}

#mwb_rwpr_setting_wrapper * {
    box-sizing: border-box;
}

.general_row_wrap {
    box-shadow: 2px 3px 20px rgba(0, 0, 0, .2);
    margin: 20px 0 40px 0;
}

.mwb_rwpr_content_template {
    color: #555d66;
    font-size: 16px;
    line-height: 28px;
}

.wpr_general_sign_title {
    width: 100%;
    display: block;
    padding: 8px 20px;
    background-color: #4f3154;
    display: block;
    color: #fff;
    font-weight: 700;
    font-size: 18px;
}

.wpr_general_row {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    align-items: center;
}

.wpr_general_sign_title {
    width: 100%;
    display: block;
    padding: 8px 20px;
    background-color: #4f3154;
    display: block;
    color: #fff;
    font-weight: 700;
    font-size: 18px;
}

#mwb_rwpr_setting_wrapper * {
    box-sizing: border-box;
}

.wpr_general_label label {
    width: 150px;
    display: inline-block;
}

.wpr_general_label {
    width: 210px;
    font-weight: 600;
}

.wpr_general_content {
    width: 100%;
    padding: 15px;
}

.wpr_general_content,
.wpr_general_label {
    padding: 13px 0;
}

.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 900px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

/* Hide the default checkbox */
.custom-checkbox input[type="checkbox"] {
    display: none;
}

/* Custom design for the checkbox container */
.custom-checkbox {
    display: inline-block;
    position: relative;
    width: 70%;
    height: 37px;
    padding: 0;
    background-color: #f9f9f9; /* Default background color */
    border: 1px solid #ced4da;
    border-radius: 5px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: background-color 0.3s ease; /* Smooth transition */
}

/* Entire background change when checked */
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
    background-color: #4CAF50; /* Green background when checked */
    color: white; /* Change checkmark color */
    border-radius: 5px;
}

/* Design for the checkmark (tick inside the checkbox) */
.custom-checkbox .checkmark {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ced4da; /* Default checkmark color */
    font-size: 14px;
    padding-left: 8px;
}

/* Style for checked checkbox (the checkmark) */
.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
    content: "\2713"; /* Unicode for checkmark */
    position: absolute;
    color: white; /* Checkmark color */
    font-size: 20px;
    font-weight: bold;
    left: 2px;
}

.checkmark:after {
    content: "\f0c8";
    font-family: "FontAwesome";
    position: absolute;
    color: rgba(0, 0, 0, 0.1);
    font-size: 20px;
    margin-top: -4px;
    transition: 0.3s;
    left: 2px;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark:after {
    content: "";
}

/* Hover effect for the checkbox */
.custom-checkbox:hover {
    background-color: #e6e6e6; /* Slightly darker background on hover */
}

/* Optional: Hover effect for checked checkbox */
.custom-checkbox input[type="checkbox"]:checked:hover + .checkmark {
    background-color: #45a049; /* Darker green when hovered and checked */
}


/* Switch button */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch_label {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

.switch_label:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .switch_label {
  background-color: #4CAF50;
}

input:checked + .switch_label:before {
  transform: translateX(26px);
}

</style>